export const EducationTooltipStorageType = {
    SHARE_WITH_TEAM: 'share_with_team',
    SPARK_YOUR_NEXT_IDEA: 'spark_your_next_idea',
    PRIVATE: 'private',
};
